import Vue from 'vue'
import $ from 'jquery'
import 'bootstrap'
import App from './App.vue'
import store from './store'
import router from './router'
import VueCurrencyFilter from 'vue-currency-filter'
import Clipboard from 'v-clipboard'
import { BootstrapVue } from 'bootstrap-vue'
import VueSocialSharing from 'vue-social-sharing'
import {
  ValidationObserver,
  ValidationProvider,
  extend
} from 'vee-validate'
import { messages } from 'vee-validate/dist/locale/en.json'
import * as rules from 'vee-validate/dist/rules'
import { PiniaVuePlugin, createPinia } from 'pinia'

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

const mappedMessages: { [key: string]: string } = messages

for (const [rule, validation] of Object.entries(rules)) {
  extend(rule, {
    ...validation,
    message: mappedMessages[rule]
  })
}

Vue.use(PiniaVuePlugin)
Vue.use(VueSocialSharing)
Vue.use(Clipboard)
Vue.config.productionTip = false

Vue.use(BootstrapVue)

Vue.use(VueCurrencyFilter,
  {
    symbol: '$',
    thousandsSeparator: ',',
    fractionCount: 2,
    fractionSeparator: '.',
    symbolPosition: 'front',
    symbolSpacing: true
  })

Vue.directive('tooltip', function (el, binding) {
  $(el).tooltip({
    title: binding.value,
    placement: 'bottom',
    trigger: 'hover'
  })

  $(el).on('show.bs.tooltip', function () {
    if (this.offsetWidth >= this.scrollWidth) {
      return false
    }
  })
})

const pinia = createPinia()

new Vue({
  pinia,
  store,
  router,
  render: h => h(App)
}).$mount('#app')

declare global {
  interface Window { cylindo: any }
}
